module.exports = __webpack_public_path__ + "img/partner-qnw.da4c634e.png";